module.exports = __webpack_public_path__ + "img/Контрактура Дюпюитрена.adac9687.jpg";